import i18n from '../locales';
import Enum from '../shared/enum'

/**
 * Return Ordinal values from list.
 * Uses Enum get ordinal values 'Primeira....Décima..."
 * @param {*} num 
 */
export const toOrdinalPrefix = num => {
  const int = num.toString(),
  ordinals = Enum._Ordinals,
  oPattern = Enum._ZeroToTen
  return num > 10
    ? ordinals[Number(int[0] - 1)] + oPattern[Number(int[1] - 1)]
    : oPattern[num - 1];
};

/**
 * Define Revalidated Test label
 * @param {*} serviceObj First review with vehicleServicingIsRevalidated = true
 * @param {*} services  List of all services for each Vehicle
 */
export const defineServiceCompletedLabel = (services, serviceObj) => {
  var firstPart  = serviceObj.vehicleServicingIsRevalidated ? i18n.t('service_history.service_revalidated') : i18n.t('service_history.service_completed_date')
  if (serviceObj.vehicleServicingIsRevalidated) {
      if (hasOtherRevalidatedReview(services, serviceObj)) {
          firstPart = i18n.t('service_history.service_completed_date')
      }
  }
  return firstPart
}

/**
 * Check if there's another REVALIDATED service
 * @param {*} serviceObj First review with vehicleServicingIsRevalidated = true
 * @param {*} services  List of all services for each Vehicle
 */
const hasOtherRevalidatedReview = (services, serviceObj) => {
  let indexReview = services.indexOf(serviceObj)

  let reviewsFilterd = services.map((mapped, index) => {
    if(index > indexReview) {
      return mapped
    }
  }).filter(filtered => filtered).filter(filtered => filtered.type !== serviceObj.type)

  return reviewsFilterd.filter(filtered => filtered.vehicleServicingIsRevalidated == true).count > 0
};